import { Building2, Users2, Award, Globe2 } from "lucide-react";
import Reveal from "../Reveal";

const stats = [
  { v: "Reports",   l: "Sales, profit & stock at a glance" },
  { v: "Offline",   l: "Keeps billing when the internet drops" },
  { v: "Cloud",     l: "Automatic, secure daily backups" },
  { v: "Multi-user", l: "Works across counters & devices" },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal><p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-800">About</p></Reveal>
            <Reveal delay={80}>
              <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900 mt-3">
                Built by people who run businesses.
              </h2>
            </Reveal>
            <Reveal delay={140}>
              <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
                <strong className="text-slate-900">Fyzeron Technologies LLP</strong> builds reliable
                billing and business management software for retail and hospitality businesses.
                FolioStax is built for supermarkets, mini markets, cafes, restaurants, grocery
                stores and retail shops — designed on real shop counters, for the way they actually work.
              </p>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-4 text-base text-slate-600 leading-relaxed">
                Our mission is simple: give every shopkeeper the tools that big brands have —
                without the complexity, without the cost.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 gap-4 sm:gap-6">
            {stats.map((s, i) => (
              <Reveal key={s.l} delay={i * 80}>
                <div className="rounded-2xl border border-slate-200 bg-slate-50/50 p-6 lg:p-8 hover:bg-white hover:shadow-md transition">
                  <p className="font-display text-3xl sm:text-4xl font-black text-slate-900 tracking-tight">
                    {s.v}
                  </p>
                  <p className="mt-2 text-sm text-slate-600">{s.l}</p>
                </div>
              </Reveal>
            ))}
            <Reveal delay={320} className="col-span-2">
              <div className="rounded-2xl bg-navy text-white p-7 lg:p-8 grain relative overflow-hidden">
                <div className="absolute -top-12 -right-12 h-48 w-48 rounded-full bg-blue-800/15 blur-3xl" />
                <div className="grid sm:grid-cols-2 gap-6 relative">
                  {[
                    { icon: Award,    t: "Trusted",         d: "Customer-first since day one." },
                    { icon: Globe2,   t: "Local + Global",  d: "Built in India, made for the world." },
                    { icon: Building2,t: "Proudly LLP",     d: "Fyzeron Technologies LLP — registered & compliant." },
                    { icon: Users2,   t: "Team you trust",  d: "Real humans on chat, email and call." },
                  ].map((b) => (
                    <div key={b.t} className="flex items-start gap-3">
                      <div className="h-10 w-10 rounded-lg bg-white/10 grid place-items-center shrink-0">
                        <b.icon className="h-5 w-5 text-blue-700" />
                      </div>
                      <div>
                        <p className="font-display font-bold">{b.t}</p>
                        <p className="text-sm text-slate-300 mt-0.5">{b.d}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
